import React from 'react';
import { FormError } from '../../common/form/form-error';
import { useFormContext } from 'react-hook-form';

export const InputCheckbox = ({
    name,
    rules,
    serverErrors,
    children,
    className
}) => {
    const {
        register,
        formState: { errors }
    } = useFormContext();

    return (
        <div className={`mb-1 ${className}`}>
            <div className="form-check form-check-sm mb-0 align-items-center">
                <input
                    id={name}
                    type="checkbox"
                    className={`form-check-input position-relative mr-1 ${
                        errors[name] ? 'is-invalid' : ''
                    }`}
                    {...register(name, rules[name])}
                />
                <label htmlFor={name} className="mb-0 size-oslo">
                    {children}
                </label>
            </div>
            <FormError
                serverErrors={serverErrors}
                errors={errors}
                name={name}
            />
        </div>
    );
};

export const Input = ({
    name,
    type,
    className,
    label,
    placeholder,
    rules,
    serverErrors
}) => {
    const {
        register,
        formState: { errors }
    } = useFormContext();

    return (
        <div>
            {label && <p className={'mb-1 font-hansen'}>{label}</p>}
            <div className={`mb-1 ${className}`}>
                <input
                    placeholder={placeholder}
                    type={type}
                    className={`form-control px-1 py-2 ${
                        errors[name] ? 'is-invalid' : ''
                    }`}
                    {...register(name, rules[name])}
                />
                <FormError
                    serverErrors={serverErrors}
                    errors={errors}
                    name={name}
                />
            </div>
        </div>
    );
};
